'use strict';

module.exports = (function() {
  // Return a shuffled copy of array
  function shuffle(array) {
    var shuffledArray = array.slice();
    for(var i = array.length; i > 0;) {
      var r = Math.floor(Math.random() * i--);
      var temp = shuffledArray[i];
      shuffledArray[i] = shuffledArray[r];
      shuffledArray[r] = temp;
    };
    return shuffledArray;
  }

  return {
    "shuffle": shuffle
  };
}());
